import { ICandidate, newMappingEntity } from 'wisestep-api';

import TechFetchCandidates from '../types/TechFetchCandidates';
import TechFetchResponse from '../types/TechFetchResponse';

export const processTechFetchResponse = (response: any): TechFetchResponse => {
  let existing: any = null;
  let noresponse = false;
  const modifiedResponse: TechFetchResponse = {
    candidates: [],
  };
  if (response.Envelope.Existing?.interaction) {
    if (Array.isArray(response.Envelope.Existing.interaction)) {
      existing = response.Envelope.Existing.interaction;
    } else {
      existing = [response.Envelope.Existing.interaction];
    }
  } else {
    existing = [];
  }

  const totalItems =
    response.Envelope.Body.ResumeSearchAdvancedResponse.ResumeSearchAdvancedResult.NewDataSet
      .Summary.TotalNumberOfResults;

  if (
    !response.Envelope.Body.ResumeSearchAdvancedResponse.ResumeSearchAdvancedResult.NewDataSet
      .Results
  ) {
    noresponse = true;
  }
  const candidates = response.Envelope.Body.ResumeSearchAdvancedResponse.ResumeSearchAdvancedResult
    .NewDataSet.Results
    ? Array.isArray(
        response.Envelope.Body.ResumeSearchAdvancedResponse.ResumeSearchAdvancedResult.NewDataSet
          .Results
      )
      ? response.Envelope.Body.ResumeSearchAdvancedResponse.ResumeSearchAdvancedResult.NewDataSet
          .Results
      : [
          response.Envelope.Body.ResumeSearchAdvancedResponse.ResumeSearchAdvancedResult.NewDataSet
            .Results,
        ]
    : [];
  const candidatesResponse = buildCandidateRecords(candidates);
  modifiedResponse.candidates = candidatesResponse;
  modifiedResponse.noResponse = noresponse;
  modifiedResponse.totalItems = totalItems;
  modifiedResponse.existing = existing;
  return modifiedResponse;
};

function buildCandidateRecords(candidates: TechFetchCandidates[]): TechFetchCandidates[] {
  candidates.map((candidate) => {
    const candidateData: ICandidate = newMappingEntity();

    candidateData.name = `${candidate.FirstName}  ${candidate.LastName}`;
    candidateData.currentJobTitle = candidate.JobTitle;
    candidateData.totalYearsExperience = candidate.TotalExperience;
    candidateData.workAuthorization = candidate.WorkAuthorization;
    candidateData.dateResumeLastUpdatedOnJobBoard = candidate.UpdatedDate;
    candidateData.currentSalary = 0;
    if (candidate.Salary?.toLowerCase() !== 'market') {
      const salary = candidate.Salary.match(/\d/g);
      candidateData.currentSalary = parseInt(salary ? salary.join('') : '0');
      candidateData.currentSalaryCurrency = 'USD';
      candidateData.currentSalaryTimeSpan = 'PerAnnum';
    } else if (candidate.Rate?.toLowerCase() !== 'market') {
      const salary = candidate.Rate.match(/\d/g);
      candidateData.currentSalary = parseInt(salary ? salary.join('') : '0');
      candidateData.currentSalaryCurrency = 'USD';
      candidateData.currentSalaryTimeSpan = 'PerHour';
    } else {
      candidateData.currentSalaryCurrency = 'USD';
      candidateData.currentSalaryTimeSpan = 'None';
    }

    if (candidate.PreferredEmployment) {
      let perHourSalary = 0;
      if (candidate.Rate?.toLowerCase() !== 'market') {
        const salary = candidate.Rate.match(/\d/g);
        perHourSalary = parseInt(salary ? salary.join('') : '0');
      }
      candidateData.workPreferences = [
        {
          employmentType: candidate.PreferredEmployment.split(','),
          annualSalary: {
            min: 0,
            max: 0,
            currency: '',
          },
          hourlyRate: {
            min: perHourSalary,
            max: perHourSalary,
            currency: 'USD',
          },
          preferredWorkAreas: [],
          travelPreference: 0,
          willingToRelocate: null,
        },
      ];
    }
    if (candidate.Skills) {
      candidateData.skills = candidate.Skills.split(',');
    }
    if (candidate.Relocation) {
      candidateData.willingToRelocate = candidate.Relocation === 'YES' ? true : false;
      candidateData.likelyToMove = candidateData.willingToRelocate;
      if (candidateData.workPreferences?.length) {
        candidateData.workPreferences[0].willingToRelocate = candidateData.willingToRelocate;
      }
    }
    if (candidate.City || candidate.Country || candidate.State || candidate.Zipcode) {
      candidateData.currentLocation = {
        city: candidate.City,
        country: candidate.Country,
        state: candidate.State,
        zipCode: candidate.Zipcode,
        continent: '',
        continentCode: '',
        countryCode: '',
        stateCode: '',
      };
    }
    candidateData.source = 'TECHFETCHSEARCH';
    candidate.candidateData = candidateData;
  });
  return candidates;
}
